// sessionStorage에 영속되는 store (탭 단위로 유지, 회원가입 완료 시 삭제)
// window.open으로 연 팝업에는 열리는 시점의 sessionStorage 스냅샷이 복제되므로,
// NICE 결과 팝업(NicePassResultPage)에서 requestNo를 읽을 수 있다.
const sessionStore = {
  namespaced: true,
  state: {
    requestNo: "",
  },
  getters: {
    getRequestNo(state) {
      return state.requestNo;
    },
  },
  mutations: {
    SET_REQUEST_NO(state, requestNo) {
      state.requestNo = requestNo;
    },
    CLEAR_REQUEST_NO(state) {
      state.requestNo = "";
    },
  },
};

export default sessionStore;
